import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm2.09-1.045A6.21 6.21 0 0 0 2 8c0 1.63.65 3.109 1.705 4.19l1.118-1.537a2 2 0 0 0-.945-3.06l-1.787-.638Zm10.021.639 1.798-.642c.06.34.091.69.091 1.048a5.98 5.98 0 0 1-1.707 4.192l-1.013-1.43a4.117 4.117 0 0 0-.241-.307 2 2 0 0 1 1.072-2.861ZM9 2.083a6.006 6.006 0 0 1 4.236 2.985l-1.567.56A2 2 0 0 1 9 3.743v-1.66Zm.549 9.747a4.135 4.135 0 0 1-.113-.164 2 2 0 0 0-3.037.236l-1.07 1.472c.805.4 1.712.626 2.671.626.96 0 1.867-.225 2.672-.626L9.549 11.83ZM2.764 5.068A6.006 6.006 0 0 1 7 2.083v1.66a2 2 0 0 1-2.673 1.883l-1.563-.558Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var IconInfrastructureTire16 = createIcon(IconComponent);